"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAzureOpenAiCredentialDtoRegion = void 0;
exports.CreateAzureOpenAiCredentialDtoRegion = {
    Australia: "australia",
    Canada: "canada",
    Eastus2: "eastus2",
    Eastus: "eastus",
    France: "france",
    India: "india",
    Japan: "japan",
    Uaenorth: "uaenorth",
    Northcentralus: "northcentralus",
    Norway: "norway",
    Southcentralus: "southcentralus",
    Swedencentral: "swedencentral",
    Switzerland: "switzerland",
    Uk: "uk",
    Westus: "westus",
    Westus3: "westus3",
};
